import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Icon, Modal, Table, Tag, Tooltip } from "antd";
import { SystemMessageUserGroupText, SystemMessageType, SystemMessageTypeText, SystemMessageStatusText } from "../../../models/enums";
import {
  getAdminSystemMessages,
  selectAdminSystemMessages,
} from "./systemMessages.ducks";

import PageTitle from "../PageTitle";
import SendSystemMessageModal from "./SendSystemMessageModal";
import SystemMessagesFilterForm from "./SystemMessagesFilterForm";
import { formatDate } from "../../../services";
import styles from "./manageSystemMessagesPage.scss";

const ManageSystemMessagesPage = () => {
  const dispatch = useDispatch();
  const messages = useSelector(selectAdminSystemMessages);

  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [previewMessage, setPreviewMessage] = useState(null);
  const [duplicateData, setDuplicateData] = useState(null);
  const [searchCriteria, setSearchCriteria] = useState({});

  const loadMessages = (criteria?) => {
    const params = criteria !== undefined ? criteria : searchCriteria;
    setLoading(true);
    dispatch(getAdminSystemMessages(params, () => {
      setLoading(false);
    }));
  };

  const handleSearch = (criteria) => {
    setSearchCriteria(criteria);
    loadMessages(criteria);
  };

  useEffect(() => {
    loadMessages();
  }, []);

  const handleDuplicate = (record) => {
    setDuplicateData({
      title: record.title ? record.title + " (duplikat)" : "",
      content: record.content || "",
      type: record.type || undefined,
      userGroup: record.userGroup !== undefined ? record.userGroup : null,
      yesPromptChoiceLabel: record.yesPromptChoiceLabel || "Da",
      noPromptChoiceLabel: record.noPromptChoiceLabel || "Ne",
    });
    setModalVisible(true);
  };

  const columns = [
    {
      title: "Naslov",
      dataIndex: "title",
      key: "title",
      width: 300,
      render: (text) => text || <em className={styles.noTitleText}>Bez naslova</em>,
    },
    {
      title: "Pošiljatelj",
      dataIndex: "senderName",
      key: "senderName",
    },
    {
      title: "Ciljna grupa",
      dataIndex: "userGroup",
      key: "userGroup",
      render: (value) => {
        if (value === undefined || value === null) return <Tag>-</Tag>;
        const group = SystemMessageUserGroupText.find((o) => o.value === value);
        return <Tag color="blue">{group ? group.name : "Grupa " + value}</Tag>;
      },
    },
    {
      title: "Tip",
      dataIndex: "type",
      key: "type",
      render: (value) => {
        const type = SystemMessageTypeText.find((o) => o.value === value);
        return <Tag>{type ? type.name : "-"}</Tag>;
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (value) => {
        const status = SystemMessageStatusText.find((o) => o.value === value);
        if (value === 1) {
          return <Tag className={styles.statusTagSent}>{status ? status.name : "-"}</Tag>;
        }
        return <Tag color="orange">{status ? status.name : "-"}</Tag>;
      },
    },
    {
      title: "Datum slanja",
      dataIndex: "sentAt",
      key: "sentAt",
      render: (value) => value ? formatDate(value) : "-",
    },
    {
      title: "Akcije",
      key: "actions",
      align: "center",
      width: 100,
      render: (_, record) => (
        <div className={styles.actionsColumn}>
          <Tooltip title="Preview">
            <Button
              onClick={(e) => { e.stopPropagation(); setPreviewMessage(record); }}
            >
              <Icon type="eye" />
            </Button>
          </Tooltip>
          <Tooltip title="Dupliciraj">
            <Button
              onClick={(e) => { e.stopPropagation(); handleDuplicate(record); }}
            >
              <Icon type="copy" />
            </Button>
          </Tooltip>
        </div>
      ),
    },
  ];

  const handleSendSuccess = () => {
    setModalVisible(false);
    setDuplicateData(null);
    setTimeout(() => {
      loadMessages();
    }, 3000);
  };

  const handleModalCancel = () => {
    setModalVisible(false);
    setDuplicateData(null);
  };

  return (
    <React.Fragment>
      <PageTitle title="Sistemske poruke" />

      <SystemMessagesFilterForm onSubmit={handleSearch} onNewMessage={() => setModalVisible(true)} />

      <Table
        rowKey="id"
        bordered
        dataSource={messages}
        columns={columns}
        rowClassName={() => ""}
        className={`admin-table ${styles.table}`}
        loading={loading}
        scroll={{ x: false }}
        pagination={false}
      />

      <Modal
        title={previewMessage ? previewMessage.title || "Sistemska poruka" : ""}
        visible={!!previewMessage}
        onCancel={() => setPreviewMessage(null)}
        footer={null}
        width={700}
      >
        {previewMessage && (
          <div>
            <div className={styles.previewMeta}>
              <span><strong>Ciljna grupa:</strong> {(SystemMessageUserGroupText.find(o => o.value === previewMessage.userGroup) || {}).name || "-"}</span>
              <span><strong>Tip:</strong> {(SystemMessageTypeText.find(o => o.value === previewMessage.type) || {}).name || "-"}</span>
              <span><strong>Status:</strong> {(SystemMessageStatusText.find(o => o.value === previewMessage.status) || {}).name || "-"}</span>
              <span><strong>Datum:</strong> {previewMessage.sentAt ? formatDate(previewMessage.sentAt) : "-"}</span>
            </div>
            <div
              className={styles.previewContent}
              dangerouslySetInnerHTML={{ __html: previewMessage.content }}
            />
            {previewMessage.type === SystemMessageType.PromptChoice && (
              <div className={styles.previewChoiceButtons}>
                <Button disabled>{previewMessage.noPromptChoiceLabel || "Ne"}</Button>
                <Button disabled>{previewMessage.yesPromptChoiceLabel || "Da"}</Button>
              </div>
            )}
          </div>
        )}
      </Modal>

      <SendSystemMessageModal
        visible={modalVisible}
        onCancel={handleModalCancel}
        onSuccess={handleSendSuccess}
        initialData={duplicateData}
      />
    </React.Fragment>
  );
};

export default ManageSystemMessagesPage;



// WEBPACK FOOTER //
// ./src/routes/Admin/ManageSystemMessagesPage/ManageSystemMessagesPage.tsx